module.exports = __webpack_public_path__ + "media/images/self-registered-a3ece62ff62741e66fb998b89c3b59ff.png";